import { Tag } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: max-content;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
`;

type Props = {
  $color: string;
  $borderColor?: string;
};

export const StyledTag = styled(Tag)<Props>`
  border: transparent;
  padding: 2px 8px;
  background-color: ${({ $color }) => $color};
  border: 1px solid ${({ $borderColor }) => $borderColor};
`;

export const TextWrapper = styled.div<Props>`
  color: ${({ $color }) => $color};
`;
